import script from "./HospitalSpecialInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalSpecialInfo.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalSpecialInfo.vue?vue&type=style&index=0&id=0b7c364a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b7c364a"]])

export default __exports__